module.exports = __webpack_public_path__ + "static/img/1.44aab10.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/2/4/sp/1.png
// module id = yJG6
// module chunks = 0